module.exports = __webpack_public_path__ + "15_hair_black.8a21ce18.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/15_hair_black.png
// module id = +xor
// module chunks = 0